<template>
  <div class="home-content">
    <common-carousel :carouselData="carouselData" />
    <div class="container" style="padding-top: 100px">
      <!-- 数字名片介绍  stat -->
      <div class="container-header">
        <img
          class="container-leftTitle"
          :src="`${$baseImgUrl}images/leftTitle.png`"
          alt=""
        />
        <span class="container-title"
          >数字名片 <span class="container-dot"></span>核心功能介绍</span
        >
        <img
          class="container-right-title"
          :src="`${$baseImgUrl}images/rightTitle.png`"
          alt=""
        />
      </div>
      <div class="container-content">
        <observer @on-change="upwardOnChange" :threshold="threshold">
          <el-row
            :gutter="75"
            class="animation animation-10 animation-upward"
            :class="{ 'visible-content': visibleContent }"
          >
            <el-col :span="8">
              <el-card class="business-card" :body-style="{ padding: '0px' }">
                <img :src="`${$baseImgUrl}images/introduce-one.png`" alt="" />

                <div style="height: 150px">
                  <div style="margin-top: 20px; text-align: center">
                    <div class="business-card-dot"></div>
                    <div class="business-card-name">分享名片</div>
                  </div>
                </div>
              </el-card>
            </el-col>
            <el-col :span="8">
              <el-card class="business-card" :body-style="{ padding: '0px' }">
                <img :src="`${$baseImgUrl}images/introduce-two.png`" alt="" />

                <div style="height: 150px">
                  <div style="margin-top: 20px; text-align: center">
                    <div class="business-card-dot"></div>
                    <div class="business-card-name">分享内容</div>
                  </div>
                </div>
              </el-card>
            </el-col>
            <el-col :span="8">
              <el-card class="business-card" :body-style="{ padding: '0px' }">
                <img :src="`${$baseImgUrl}images/introduce-three.png`" alt="" />

                <div style="height: 150px">
                  <div style="margin-top: 20px; text-align: center">
                    <div class="business-card-dot"></div>
                    <div class="business-card-name">营销推广</div>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </observer>

        <!-- 数字名片介绍  end -->
      </div>
    </div>
    <!-- 雷达系统 -->
    <observer @on-change="rightOnChange" :threshold="threshold">
      <div
        class="container-bottom"
        :class="{ 'visible-container-bottom': visibleBottom }"
      >
        <div class="container-bottom-radar animation-10 animation-right">
          <img
            :src="`${$baseImgUrl}images/radar.png`"
            alt=""
            style="float: left"
          />

          <div style="padding-top: 270px">
            <h1>雷达系统</h1>
            <div class="container-bottom-describe">
              <p>雷达系统自动捕获客户的浏览轨迹，</p>
              <p style="padding-top: 12px">精准构建客户画像</p>
            </div>
          </div>
        </div>
      </div>
    </observer>

    <div class="qr-code-footer flex-display flex-right-align">
      <div class="footer-bg-frame flex-display flex-center-pack">
        <img
          :src="`${$baseImgUrl}images/business-card-footer-bg.png`"
          class="footer-bg"
          alt=""
        />
        <div class="container flex-display flex-center-pack">
          <div class="left flex-display flex-center-align">
            <span class="text">扫描二维码</span>
            <span class="text">体验更多数字名片功能</span>
          </div>
          <img
            :src="`${$baseImgUrl}images/business-card-footer-qr-code.png`"
            class="qr-code"
            alt=""
          />
          <div class="right flex-display flex-display-column flex-center-pack">
            <span class="title">数字名片</span>
            <span class="sub-title">微信公众号</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import commonCarousel from '@/components/common/carousel'
import Observer from '@/components/index.js'

export default {
  components: {
    commonCarousel, Observer
  },

  data () {
    return {
      visibleContent: false, // 显示-向上的动画效果
      visibleBottom: false, // 显示-向左/右动画效果
      threshold: [1], // [0, 0.25, 0.5, 0.75, 1] 1：元素百分百滑动到可见区域时
      carouselData: [
        {
          title: '数字名片',
          subTitle: '营销拓客工具',
          icon: `${this.$baseImgUrl}images/businessCard-slideshowIcon-1.png`,
          rightImg: `${this.$baseImgUrl}images/businessCard-slideshowRight-1.png`,
          url: `${this.$baseImgUrl}images/businessCard-slideshow-1.png`,
          video: `${this.$baseImgUrl}videos/1-website.mp4`
        }
      ]
    }
  },
  mounted () {
    // 监听滚动条
  },
  methods: {
    upwardOnChange (entry) {
      // 向上-动画
      if (!this.visibleContent) {
        this.visibleContent = entry.isIntersecting
      }
    },
    rightOnChange (entry) {
      // 左右-动画
      if (!this.visibleBottom) {
        this.visibleBottom = entry.isIntersecting
      }
    }
  }
}
</script>

<style  lang="less" scoped>
@headerHeight: 120px;
.home-content {
  margin-top: 70px;
}
.container-header {
  text-align: center;
}
.container-title {
  font-size: 32px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 45px;
}
.container-dot {
  width: 6px;
  height: 6px;
  margin: 0 10px;
  display: inline-block;
  background: rgb(38, 110, 236);
  position: relative;
  left: -4px;
  top: -6px;
}
.container-leftTitle {
  padding-right: 20px;
}
.container-right-title {
  padding-left: 20px;
}
.container-content {
  padding-top: 60px;
}
.business-card {
  position: relative;
  height: 380px;
}
.business-card-dot {
  width: 20px;
  height: 4px;
  background: #266eec;
  margin: 0 auto;
  margin-bottom: 16px;
}
.business-card-name {
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
}
.container-bottom {
  margin-top: 100px;
  background: #f5f8fe;
  height: 700px;
}
.container-bottom-radar {
  width: 1200px;
  margin: 0 auto;
}
.container-bottom-describe {
  padding-top: 40px;
  font-size: 20px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  p {
    color: #666666;
  }
}

// 动画-上
.animation-upward {
  opacity: 0;
  transform: translateY(50px);
  transform: translateY(50px);
  -ms-transform: translateY(50px);
  -moz-transform: translateY(50px);
  -webkit-transform: translateY(50px);
  -o-transform: translateY(50px);
}

.visible-content.animation-upward {
  transform: translateY(0);
  transform: translateY(0);
  -ms-transform: translateY(0);
  -moz-transform: translateY(0);
  -webkit-transform: translateY(0);
  -o-transform: translateY(0);
  opacity: 1;
}
// 动画-右
.animation-right {
  opacity: 0;
  transform: translateX(100px);
  transform: translateX(100px);
  -ms-transform: translateX(100px);
  -moz-transform: translateX(100px);
  -webkit-transform: translateX(100px);
  -o-transform: translateX(100px);
}

.container-bottom.visible-container-bottom .animation-right {
  transform: translateX(0);
  transform: translateX(0);
  -ms-transform: translateX(0);
  -moz-transform: translateX(0);
  -webkit-transform: translateX(0);
  -o-transform: translateX(0);
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/pages/goods/businessCard.vue